import { Grid, Stack, Typography } from '@mui/material';

const RiskAssessmentsStatus: React.FC<RiskAssessmentsProps> = (props) => {
  const {
    totalAssessments,
    completedStatus,
    inProgressStatus,
    assessmentsOnAIStatus,
  } = props;
  return (
    <Grid container className="risk-assessments-container">
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">Total assessments</Typography>
          <Typography variant="body1">{totalAssessments}</Typography>
        </Stack>
      </Grid>
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">Completed</Typography>
          <Typography variant="body1">{completedStatus}</Typography>
        </Stack>
      </Grid>
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">In progress </Typography>
          <Typography variant="body1">{inProgressStatus}</Typography>
        </Stack>
      </Grid>
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">Assessments on AIs</Typography>
          <Typography variant="body1">{assessmentsOnAIStatus}</Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default RiskAssessmentsStatus;
